import {Component, type OnInit} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-sensores',
    standalone: false,
    templateUrl: './sensores.component.html',
    styleUrls: ['./sensores.component.scss']
})
export class SensoresComponent implements OnInit {

    public showCargando = false;
        
    public thebluedotsURL: string | SafeResourceUrl = 'https://sysinta.com/SBC-AbderaGreen/login.php';
    
    constructor(private readonly dom: DomSanitizer) { 
        void dom;
    }

    ngOnInit(): void { 
       const baseUrl = 'https://sysinta.com/SBC-AbderaGreen/login.php';
       
       this.thebluedotsURL = this.dom.bypassSecurityTrustResourceUrl(baseUrl);
    }
}